const HEX = /^#[0-9A-Fa-f]{6}$/;

export function contrastFg(hex) {
  if (!HEX.test(hex || "")) return "#FFFFFF";
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return L > 0.4 ? "#0F172A" : "#FFFFFF";
}

export function contrastRatio(a, b) {
  const lum = (hex) => {
    const [r, g, bl] = [1, 3, 5].map((i) => {
      const c = parseInt(hex.slice(i, i + 2), 16) / 255;
      return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * bl;
  };
  if (!HEX.test(a) || !HEX.test(b)) return 0;
  const [x, y] = [lum(a), lum(b)].sort((m, n) => n - m);
  return (x + 0.05) / (y + 0.05);
}

export function brandVars(primary, secondary) {
  const p = HEX.test(primary || "") ? primary : "#0038A8";
  const s = HEX.test(secondary || "") ? secondary : "#CE1126";
  return {
    "--brand-primary": p, "--brand-secondary": s,
    "--brand-primary-fg": contrastFg(p), "--brand-secondary-fg": contrastFg(s),
  };
}

export function applyBrand(b) {
  if (!b) return;
  const vars = brandVars(b.primary_color, b.secondary_color);
  Object.entries(vars).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
  document.title = `${b.lgu_name} — ${b.system_name}`;
}
